var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteiconsSvg14(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2620_1409)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.4971 12.8523C24.444 11.7692 22.1916 11.1159 19.8775 10.9324C17.5635 10.7488 15.2363 11.0389 13.038 11.7847C10.8398 12.5306 8.81662 13.7167 7.09206 15.2705C5.3675 16.8244 3.97774 18.7134 3.00762 20.8223C2.0375 22.9312 1.50738 25.2157 1.44962 27.5363C1.39187 29.857 1.8077 32.165 2.67171 34.3195C3.53573 36.4741 4.8298 38.4299 6.47493 40.0677C8.12006 41.7054 10.0817 42.9906 12.2401 43.8449L16.5116 32.8909C15.3055 32.4201 14.3027 31.5413 13.6777 30.4074C13.0528 29.2735 12.8454 27.9563 13.0915 26.6852C13.3377 25.4141 14.0219 24.2696 15.0249 23.4509C16.028 22.6323 17.2864 22.1914 18.5811 22.2049C19.8757 22.2185 21.1246 22.6857 22.1103 23.5252C23.0959 24.3648 23.756 25.5234 23.9754 26.7994C24.1948 28.0754 23.9598 29.3879 23.3112 30.5085C22.6626 31.629 21.6416 32.4866 20.4258 32.9319L24.7817 43.8545C28.7333 42.2934 31.9625 39.3175 33.8404 35.5063C35.7183 31.695 36.1104 27.3212 34.9404 23.2367",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.391 7.04785H28.5109C27.4925 7.04785 26.667 7.87341 26.667 8.89179V21.1718C26.667 22.1902 27.4925 23.0158 28.5109 23.0158H47.391C48.4094 23.0158 49.235 22.1902 49.235 21.1718V8.89179C49.235 7.87341 48.4094 7.04785 47.391 7.04785Z",
    stroke: "#527DEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9238 10.1353L44.0132 14.2246C44.2273 14.4388 44.3476 14.7292 44.3476 15.0321C44.3476 15.3349 44.2273 15.6254 44.0132 15.8396L39.9238 19.9289",
    stroke: "#527DEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9785 19.9289L31.8892 15.8396C31.675 15.6254 31.5547 15.3349 31.5547 15.0321C31.5547 14.7292 31.675 14.4388 31.8892 14.2246L35.9785 10.1353",
    stroke: "#527DEB",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2620_1409"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.339844 0.451172)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteiconsSvg14);
export default __webpack_public_path__ + "static/media/Website icons SVG-14.fdb4abf5843242bf42720240559d4a7d.svg";
export { ForwardRef as ReactComponent };